// extracted by mini-css-extract-plugin
module.exports = {"main":"SocialNetworks_main__2Rukt","item":"SocialNetworks_item__2wizl"};